export const THEME_KEYS = {
  sliceName: 'theme',
  mode: 'mode',
} as const
